// http://{root}/contact
import Image from 'next/image'
import Head from 'next/head'


export const metadata = {
	title: "Contact",
	description: "",
};

export default function Contact() {
	return (<>
		<Head>
			<title>{metadata.title}</title>
		</Head>
		<div className='ContactDiv'>
			<h1>Contact</h1>
			<p>Send us a message!</p>
		</div>
	</>
  )
}